import { Component, OnInit, ViewChild, Injectable } from '@angular/core';
import { ActivatedRoute, Router,ActivatedRouteSnapshot } from '@angular/router';
import { HomeService } from '../_services/home.service';
import { NgForm, FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from '../_services';
import { Title } from '@angular/platform-browser';
import { GoogleAnalyticsService } from '../_services/google-analytics.service';
@Component({
  selector: 'app-survey-creation',
  templateUrl: './survey-creation.component.html',
  styleUrls: ['./survey-creation.component.scss'],
  providers: [NgbModalConfig, NgbModal]
})
export class SurveyCreationComponent implements OnInit {
  surveyform: FormGroup;
  surveyFields: any;
  i18n: any;
  defaultSurvey: boolean;
  referenceId: any;
  referencedSurvey: any;
  surveyName: any;
  ticketLabel: any;
  surveyDescription: any;
  surveyId: any;
  route: ActivatedRouteSnapshot;
  surveyQuestionFields: any;
  questionField: Array<any>;
  selection = [

  ];
  @ViewChild('content') content;
  ticket: string;
  ticketReceived: string;
  selectedOption: any[] = [];
  radioOption: any;
  accepted: Boolean = false;
  selectedOpt: any;
  totalOptions: any[] = [];
  defaultSurveyFields: any;
  ticketLabelParam: any;
  defaultCustomSurvey: any;
  field: {};
  referenceInst: any = "";
  hide: boolean;
  public savedOptions: boolean;
  selectedId: any;
  controlForms: FormControl;
  value: any;
  disableSubmit: boolean;
  errorMsg: boolean = false;
  defaultInstSurvey:boolean=false;
  name: any;
  Errorname: any;
  inst: any;

  constructor(private activatedRoute: ActivatedRoute,
   private routes: ActivatedRoute,
    private homeService: HomeService,
    private router: Router,
    private formBuilder: FormBuilder,
    private gaService : GoogleAnalyticsService,
    config: NgbModalConfig, private authService: AuthenticationService,
    private modalService: NgbModal, private spinner: NgxSpinnerService, private titleService: Title) {
    this.surveyform = this.formBuilder.group({
      singleOption: ['', [Validators.required]],
      plainText: ['', [Validators.required]],
      textArea: ['', []],
      dropDown: ['', [Validators.required]],
      surveyMultiSelectQuestions: this.formBuilder.array([], [Validators.required])

    })
    this.activatedRoute.queryParams.subscribe(params => {
      this.ticketLabelParam = params['ticket'];
    });
    config.backdrop = 'static';
    config.keyboard = false;
  }

  openModal() {
    this.modalService.open(this.content);
  }

  closeModal() {
    this.modalService.dismissAll('Cross click')
  }

  trackByFn(i: number) {
    return i;
  }
  ngOnInit() {
    // let pageTitle = JSON.parse(this.homeService.getPageTitleValue());
    // this.gaService.setPageTitle(pageTitle.surveyPageTitle);
    this.gaService.updatePageName();
    if (sessionStorage.getItem('i18n')) {
      this.i18n = JSON.parse(sessionStorage.getItem('i18n'));
    }
    this.surveyform = this.formBuilder.group({
      singleOption: ['', [Validators.required]],
      plainText: ['', [Validators.required]],
      textArea: ['', []],
      dropDown: ['', [Validators.required]],
      surveyMultiSelectQuestions: this.formBuilder.array([], [Validators.required])

    })
    this.ticketReceived =  this.ticketLabelParam; //localStorage.getItem('ticket');
    var number = this.ticketReceived.split(/(\d+)/);
   this.inst = number.slice(1,2);
    this.ticket = number.slice(3, 4).join("");
    this.homeService.getDefaultSurveyFields(this.inst ).subscribe(res => {
      if (res != null) {
        this.defaultSurvey = true;
      }
    })
  
    

    this.homeService.getAllSurveyFields(this.inst ).subscribe(res => {
      this.surveyFields = res.return_body
      if (!this.defaultSurvey) {
        for (let survey of this.surveyFields) {
          if (!survey.activateSurveyConfig && survey.surveyCommonConfig.defaultCustomSurvey) {
            this.defaultCustomSurvey = survey.surveyCommonConfig.defaultCustomSurvey;
            this.surveyName = survey.surveyCommonConfig.name;
            this.surveyDescription = survey.surveyCommonConfig.description;
            this.ticketLabel = survey.surveyCommonConfig.ticketNumberLabel;
            this.surveyId = survey.surveyCommonConfig.id
            console.log("surveyId :", this.surveyId)
            this.homeService.getSurveyFields(this.surveyId,this.inst ).subscribe(res => {
              this.surveyQuestionFields = res.return_body;
              this.questionField = this.surveyQuestionFields.surveyQuestions.surveyQuestionConfiguration;
              console.log("question fields are", this.questionField)
              for (let questions of this.questionField) {
                if (questions.value == null && questions.secondarySurveyType == "DROPDOWN") {
                  questions.value = "";
                }
              }
            })
          }
        }
      }
      for (let activateSurvey of this.surveyFields) {
        if (activateSurvey.activateSurveyConfig && !activateSurvey.surveyCommonConfig) {
          this.referenceInst = activateSurvey.activateSurveyConfig.referenceId;
          this.homeService.getReferenceSurvey(activateSurvey.activateSurveyConfig.referenceId).subscribe(res => {
            this.defaultSurveyFields = res.return_body;
            for (let survey of this.defaultSurveyFields) {
              if (!survey.activateSurveyConfig && survey.surveyCommonConfig.defaultCustomSurvey) {
                this.defaultCustomSurvey = survey.surveyCommonConfig.defaultCustomSurvey;
                this.surveyName = survey.surveyCommonConfig.name;
                this.surveyDescription = survey.surveyCommonConfig.description;
                this.ticketLabel = survey.surveyCommonConfig.ticketNumberLabel;
                this.surveyId = survey.surveyCommonConfig.id
                this.homeService.getReferenceSurveyFields(this.referenceInst, this.surveyId).subscribe(res => {
                  this.surveyQuestionFields = res.return_body;
                  this.questionField = this.surveyQuestionFields.surveyQuestions.surveyQuestionConfiguration;
                  for (let questions of this.questionField) {
                    if (questions.value == null && questions.secondarySurveyType == "DROPDOWN") {
                      questions.value = "";
                    }
                  }
                })

              }
            }
          })
        }
      }

    })
    this.homeService.isactive(this.router.routerState.snapshot.url.split('/')[1]).then( (data: boolean)=>{
if(data){
 this.defaultInstSurvey=true;
}
else{
  this.defaultInstSurvey=false;
}
    })


  }
  public onSaveUsernameChanged(value: boolean) {
    this.savedOptions = value;

  }


  toggleSelection(id) {
    var index = this.selectedOpt.indexOf(id);
    this.selectedOpt.splice(index, 1);
    this.selectedOpt.push(id);
  };

  handleNavigation() {
    this.router.navigate([this.router.url.split("/")[1], 'home']);
    this.closeModal();
    
  }
  onOptionChange(option) {
    this.selectedOption = option
    this.totalOptions.push(this.selectedOption)
  }
  onRadioOption(options) {
    this.radioOption = options
  }

  getQuestions() {
    let surveyQuestionConfigurationList = [];
    for (let i = 0; i < this.questionField.length; i++) {
      if (this.questionField[i].secondarySurveyType == "MULIPLE_OPTION") {
        let formValue = this.surveyform.controls;
        const surveyMultiSelectQuestions: FormArray = this.surveyform.get('surveyMultiSelectQuestions') as FormArray;
        let name = this.questionField[i].questionName
        if (this.questionField[i].questionName == name) {
          if (this.surveyform.get(name)) {
            this.field = {
              order: "",
              required: this.questionField[i].required,
              hideCheckBox: this.questionField[i].hideCheckBox,
              questionName: this.questionField[i].questionName,
              displayLayout: this.questionField[i].displayLayout,
              secondarySurveyType: this.questionField[i].secondarySurveyType,
              value: this.surveyform.get(name).value,
              optionConfiguration: null

            }
            surveyQuestionConfigurationList.push(this.field)
          }
          if (!this.surveyform.get(name) && !this.questionField[i].required) {
            this.field = {
              order: "",
              required: this.questionField[i].required,
              hideCheckBox: this.questionField[i].hideCheckBox,
              questionName: this.questionField[i].questionName,
              displayLayout: this.questionField[i].displayLayout,
              secondarySurveyType: this.questionField[i].secondarySurveyType,
              value: [],
              optionConfiguration: null

            }
            surveyQuestionConfigurationList.push(this.field)
          }
          if (!this.surveyform.get(name) && this.questionField[i].required) {
            this.spinner.hide();
            this.errorMsg = true
            this.Errorname = name;
            return;
          }


        }

      }
      if (this.questionField[i].secondarySurveyType != "MULIPLE_OPTION") {
        this.field = {
          order: "",
          required: this.questionField[i].required,
          hideCheckBox: this.questionField[i].hideCheckBox,
          questionName: this.questionField[i].questionName,
          displayLayout: this.questionField[i].displayLayout,
          secondarySurveyType: this.questionField[i].secondarySurveyType,
          value: [this.questionField[i].value],
          optionConfiguration: null

        }
        surveyQuestionConfigurationList.push(this.field)
      }

    }
    this.spinner.show();
    return surveyQuestionConfigurationList;
  }


  SaveSurvey(form: NgForm) {
    this.surveyFields = {
      activateSurveyConfig: {
        activateSuvey: true,
        surveyType: "CUSTOMIZE_SURVEY",
        referenceId: this.referenceInst
      },
      surveyCommonConfig: {
        id: this.surveyId,
        name: this.surveyName,
        description: this.surveyDescription,
        ticketNumberLabel: this.ticketLabel,
        defaultCustomSurvey: this.defaultCustomSurvey,
        value: ""
      },
      surveyQuestions: {

        surveyQuestionConfiguration: this.getQuestions()
      }


    };
 
    this.homeService.postSurveyFields(this.surveyFields, this.ticket, this.inst ).subscribe(res => {
      if (res.return_body != null) {
        this.spinner.hide();
        this.errorMsg = false;
        this.openModal();
      }
    })
  }
  getOptionList(event, question) {
    const surveyMultiSelectQuestions: FormArray = this.surveyform.get('surveyMultiSelectQuestions') as FormArray;
    if (event.target.checked) {
      let formValue = this.surveyform.controls;
      if (this.surveyform.contains(question)) {
        let value = []
        for (let arrayValue of this.surveyform.get(question).value) {
          value.push(arrayValue)
        }
        value.push(event.target.value),
          this.surveyform.get(question).setValue(value)
      }
      else {
        let value = []
        value.push(event.target.value)
        this.surveyform.addControl(question, (new FormControl(value, Validators.required)));
      }
    }
    else {
      let formValue = this.surveyform.controls;
      return this.surveyform.removeControl(question);

    }
  }

  ngAfterViewInit(){
    this.gaService.setPageTitleForSurveyPage();
  }  

}


